import { useMutation } from '@tanstack/react-query';
import { bulkApproveBankOperation } from 'config/requests/bankOperations';
import { queryClient } from 'providers/queryClient';
import { useNotify } from 'react-admin';

export function useBulkApproveRequestsBankOps() {
  const notify = useNotify();

  const mutation = useMutation({
    mutationFn: ({ ids }: { ids: number[] }) => bulkApproveBankOperation(ids),
    onSuccess: async (_, { ids }) => {
      await queryClient.invalidateQueries({ queryKey: ['bank_operations/pending_statuses'] });

      notify(`Заявка на банковскую операцию ID ${ids.join(', ')} переведена в статус Согласована`, {
        type: 'success',
      });
    },
  });

  return { bulkApproveRequestsBankOps: mutation };
}
